import { httpApi } from '@app/api/http.api';
import {
  Slider,
  CreateSliderDto,
  UpdateSliderDto,
  SliderPaginatedResponse,
  SliderFilters,
} from '@app/types/api.types';

export const createSlider = (data: CreateSliderDto): Promise<Slider> =>
  httpApi.post<Slider>('/sliders', data).then(({ data }) => data);

export const getSliders = (filters?: SliderFilters): Promise<SliderPaginatedResponse> =>
  httpApi
    .get<SliderPaginatedResponse>('/sliders', { params: filters })
    .then(({ data }) => data);

export const getSliderById = (id: string): Promise<Slider> =>
  httpApi.get<Slider>(`/sliders/${id}`).then(({ data }) => data);

export const updateSlider = (id: string, data: UpdateSliderDto): Promise<Slider> =>
  httpApi.patch<Slider>(`/sliders/${id}`, data).then(({ data }) => data);

export const deleteSlider = (id: string): Promise<void> =>
  httpApi.delete<void>(`/sliders/${id}`).then(() => undefined);

